import type { BanWordsRegexPatterns } from './utils';
import { processWithWhiteList } from './utils';

export const hasBanWords = (
  message: string,
  patterns: BanWordsRegexPatterns,
): boolean => {
  if (!message || typeof message !== 'string') return false;

  return processWithWhiteList(
    message,
    patterns.whiteListRegex,
    processedMessage => {
      const regexes = [
        patterns.blackListRegex,
        patterns.innerRegex,
        patterns.isolatedRegex,
      ];

      return regexes.some(regex => {
        if (!regex) return false;
        regex.lastIndex = 0;
        return regex.test(processedMessage);
      });
    },
  );
};
